import React from 'react';

function StatusDot(props) {
    const fill = props.fill;
    const stroke = props.stroke;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="12" 
            height="12" 
            viewBox="0 0 12 12" 
            fill="none"
            className={className}
        >
            <circle 
                cx="6" 
                cy="6" 
                r="6" 
                fill={fill}
            />
            {stroke && (
                <circle 
                    cx="6" 
                    cy="6" 
                    r="5" 
                    fill="none"
                    stroke={stroke}
                    strokeWidth="1"
                />
            )}
        </svg>
    )
};

export default StatusDot;